import App from "@/vue/App.vue";
import { createApp } from "vue";

// Import our CSS
import "@/css/app.css";

const main = async () => {
// Create our vue instance
const app = createApp(App);
 // Mount the app
return app.mount("#component-container");
};

main();

// const app = createApp({
//   components: {
//     App,
//     TestVue,
//   },
// });

// const app = createApp(App);
// app.mount("#component-container");

// createApp(InfoHeader).mount("#info-header");

// createApp(AccordionTrek).mount("#accordion-container");

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}